import React, { useEffect, useMemo, useState } from "react";
import {
  TextField,
  MenuItem,
  Button,
  Checkbox,
  FormControlLabel,
  Divider,
  Select,
  OutlinedInput,
  Typography,
  Chip,
  Input,
  Switch,
  Radio,
  Box,
  CircularProgress,
  FormHelperText,
} from "@mui/material";
import { CalendarToday } from "@mui/icons-material";
import keyicon from "../../assets/svg/SideBar/keyicon.svg";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "./generationkey.css";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  CreateSticcher,
  GetElementsSidebar,
  Keygenreation,
} from "../../store/keygenreration/action";
import {
  Getentrprise,
  previousLicenseDetails,
} from "../../store/enterprise/action";
import dayjs from "dayjs";
import { toast, ToastContainer } from "react-toastify";

const GenerateKey = () => {
  const [selectedElements, setSelectedElements] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [numAdmins, setNumAdmins] = useState("");
  const [isPerpetual, setIsPerpetual] = useState(false);
  const [isPerpetual2, setIsPerpetual2] = useState(false);
  const [isPerpetualAuditor, setIsPerpetualAuditor] = useState(false);
  const [numEndUsers, setNumEndUsers] = useState("");
  const [numPowerUsers, setNumPowerUsers] = useState("");
  const [numAuditorUsers, setNumAuditorUsers] = useState("");
  const [ClientName, setClientName] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enterpriseslist } = useSelector((state) => state.enterprises);
  const { elementsSidebar } = useSelector((state) => state?.keygenreration);
  const [errors, setErrors] = useState({});
  const [extenalUser, setExtenalUser] = useState(false);
  const [screenerStudioOrClykOps, setScreenerStudioOrClykOps] =
    useState("screenerStudio");
  const [numrecordings, setNumRecordings] = useState(null);
  const [NumberOfSticher, setNumberOfSticher] = useState(null);
  const [isPerpetualRecordings, setIsPerpetualRecordings] = useState(false);
  const [selectedUserDataFields, setSelectedUserDataFields] = useState([
    "EmployeeNumber",
  ]);

  useEffect(() => {
    dispatch(GetElementsSidebar());
    const payload = { ParentID: null };
    dispatch(Getentrprise(payload));
  }, [dispatch]);

  const handleElementChange = (event) => {
    const {
      target: { value },
    } = event;
    const selectedValues = elementsSidebar.data.filter((element) =>
      value.includes(element.ModuleName),
    );
    setSelectedElements(selectedValues);
    validateSelectedElements(selectedValues);
  };

  const validateSelectedElements = (elements) => {
    if (elements.length === 0) {
      setErrors((prev) => ({
        ...prev,
        selectedElements: "At least one element must be selected.",
      }));
    } else {
      setErrors((prev) => ({ ...prev, selectedElements: undefined }));
    }
  };

  const getPreviousDetails = async (EnterpriseID, extendUsers) => {
    const payload = {
      EnterpriseID,
      IsExtendedLicense: !extendUsers,
    };
    if (EnterpriseID) {
      const resp = await dispatch(previousLicenseDetails(payload));
      const elements = await elementsSidebar.data.filter((element) =>
        resp?.payload?.ModuleTypeIDs?.includes(element?.ModuleTypeID),
      );
      setSelectedElements(elements);
      if (!extendUsers) {
        const expDate = new Date(resp?.payload?.ValidityTo);
        setNumAdmins(resp?.payload?.NumberOfAdminUsers);
        setNumEndUsers(resp?.payload?.NumberOfEndUsers);
        setNumPowerUsers(resp?.payload?.NumberOfProcessOwnerUsers);
        setNumAuditorUsers(resp?.payload?.NumberOfAuditorUsers);
        setStartDate(dayjs(expDate.setDate(expDate.getDate() + 1)));
        setEndDate(null);
        setIsPerpetual(resp?.payload?.PerpetualEndUser);
        setIsPerpetual2(resp?.payload?.PerpetualProcessOwner);
        setIsPerpetualAuditor(resp?.payload?.PerpetualAuditor);
      } else {
        setNumAdmins(resp?.payload?.NumberOfAdminUsers);
        setNumEndUsers(resp?.payload?.NumberOfEndUsers);
        setNumPowerUsers(resp?.payload?.NumberOfProcessOwnerUsers);
        setNumAuditorUsers(resp?.payload?.NumberOfAuditorUsers);
        setIsPerpetual(resp?.payload?.PerpetualEndUser);
        setIsPerpetual2(resp?.payload?.PerpetualProcessOwner);
        setIsPerpetualAuditor(resp?.payload?.PerpetualAuditor);
        setStartDate(dayjs(resp?.payload?.ValidityFrom));
        setEndDate(dayjs(resp?.payload?.ValidityTo));
      }
    }
  };

  const handleOrganizationChange = (e) => {
    setClientName(e.target.value);
    setErrors((prev) => ({ ...prev, ClientName: undefined }));
    getPreviousDetails(e.target.value, extenalUser);
  };

  const handleLicenseTypeChange = (e) => {
    setExtenalUser(e.target.checked);
    getPreviousDetails(ClientName, e.target.checked);
  };

  const handleChange = (setter, fieldName) => (event) => {
    setter(event.target.value);
    // Clear error when user starts typing
    if (errors[fieldName]) {
      setErrors((prev) => ({ ...prev, [fieldName]: undefined }));
    }
    validateForm();
  };

  const validateForm = () => {
    const newErrors = {};

    if (!ClientName) {
      newErrors.ClientName = "Client Name is required.";
    }

    if (screenerStudioOrClykOps === "ClykOps") {
      if (!selectedElements.length) {
        newErrors.selectedElements = "At least one element must be selected.";
      }

      if (!numAdmins) {
        newErrors.numAdmins = "Number of Admins is required.";
      } else if (isNaN(numAdmins) || Number(numAdmins) <= 0) {
        newErrors.numAdmins = "Admins must be a positive number.";
      }

      if (!selectedUserDataFields || selectedUserDataFields.length === 0) {
        newErrors.selectedUserDataFields =
          "At least one user data field must be selected.";
      }
    }

    if (!startDate) {
      newErrors.startDate = "Start Date is required.";
    }

    if (!endDate) {
      newErrors.endDate = "End Date is required.";
    } else if (startDate && endDate && endDate.isBefore(startDate)) {
      newErrors.endDate = "End Date must be after Start Date.";
    }

    if (
      !isPerpetual &&
      (!numEndUsers || isNaN(numEndUsers) || Number(numEndUsers) < 0)
    ) {
      newErrors.numEndUsers = "Enter valid End Users or mark as Perpetual.";
    }

    if (
      screenerStudioOrClykOps === "ClykOps" &&
      !isPerpetual2 &&
      (!numPowerUsers || isNaN(numPowerUsers) || Number(numPowerUsers) < 0)
    ) {
      newErrors.numPowerUsers = "Power Users must be non-negative.";
    }

    // if (
    // screenerStudioOrClykOps === "ClykOps" &&
    // !isPerpetualAuditor &&
    // (!numAuditorUsers ||
    // isNaN(numAuditorUsers) ||
    // Number(numAuditorUsers) < 0)
    // ) {
    // newErrors.numAuditorUsers = "Auditor Users must be non-negative.";
    // }

    if (screenerStudioOrClykOps === "screenerStudio") {
      if (
        !isPerpetualRecordings &&
        (!numrecordings || isNaN(numrecordings) || Number(numrecordings) < 0)
      ) {
        newErrors.numrecordings =
          "Valid recordings count is required or mark Perpetual.";
      }
    }
    console.log("newErrors", newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleClick = async () => {
    if (!validateForm()) {
      toast.error("Please fix the form errors before submitting.");
      return;
    }

    setLoading(true);

    try {
      if (screenerStudioOrClykOps === "screenerStudio") {
        // For Screener Studio, use the payload structure you provided
        const enterprise = enterpriseslist.find(
          (el) => el.EnterpriseID === ClientName,
        );
        const payload = {
          ClientID: enterprise.EnterpriseID,
          LicenseKey: enterprise?.EnterpriseToken,
          NumberOfEndUsers: Number(numEndUsers) || 0,
          PerpetualEndUser: isPerpetual,
          NumberOfRecordings: Number(numrecordings) || 0,
          NumberOfAdminUsers: 0, // Hardcoded as per your payload example
          PerpetualRecordings: isPerpetualRecordings,
          NumberOfSticher: Number(NumberOfSticher) || 0,
          PerpetualSticher: false, // Hardcoded as per your payload example
          ValidityFrom: startDate.format("YYYY-MM-DD"),
          ValidityTo: endDate.format("YYYY-MM-DD"),
          IsExtendedLicense: !extenalUser,
        };

        const res = await dispatch(CreateSticcher(payload));

        if (res?.meta?.requestStatus === "fulfilled") {
          navigate(`/key`, {
            state: { OrganizationStructureID: ClientName, ...res },
          });
        } else if (res?.error) {
          const errorMessage = res.payload?.message || "An error occurred";
          toast.error(errorMessage);
        }
      } else {
        // For ClykOps, use the different payload structure
        const moduleIds = selectedElements.map(
          (element) => element.ModuleTypeID,
        );
        const enterprise = enterpriseslist.find(
          (el) => el.EnterpriseID === ClientName,
        );
        const payload = {
          EnterpriseID: ClientName,
          ModuleTypeIDs: moduleIds,
          NumberOfEndUsers: Number(numEndUsers) || 0,
          NumberOfProcessOwnerUsers: Number(numPowerUsers) || 0,
          NumberOfAuditorUsers: Number(numAuditorUsers) || 0,
          PerpetualProcessOwner: isPerpetual2,
          PerpetualEndUser: isPerpetual,
          PerpetualAuditor: isPerpetualAuditor,
          NumberOfAdminUsers: Number(numAdmins) || 0,
          ValidityFrom: startDate.format("YYYY-MM-DD"),
          ValidityTo: endDate.format("YYYY-MM-DD"),
          MacInterFaces: enterprise?.MacInterFaces,
          IsExtendedLicense: !extenalUser,
          HostName: enterprise?.HostName,
          MachineUUID: enterprise?.MachineUUID,
          DriveSerialNumber: enterprise?.DriveSerialNumber,
          OSSerialNumber: enterprise?.OSSerialNumber,
          UserIdentityField: selectedUserDataFields,
        };

        console.log("ClykOps Payload:", payload);

        const res = await dispatch(Keygenreation(payload));

        if (res?.meta?.requestStatus === "fulfilled") {
          navigate(`/key`, {
            state: { OrganizationStructureID: ClientName, ...res },
          });
        } else if (res?.error) {
          const errorMessage = res.payload?.message || "An error occurred";
          toast.error(errorMessage);
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("An unexpected error occurred");
    } finally {
      setLoading(false);
    }
  };

  const filteredEnterprises = useMemo(() => {
    return enterpriseslist.filter((enterprise) => {
      if (screenerStudioOrClykOps === "screenerStudio") {
        return enterprise.EnterpriseType === "ScreenerStudio";
      } else if (screenerStudioOrClykOps === "ClykOps") {
        return enterprise.EnterpriseType === "ClykOps";
      }
      return true;
    });
  }, [enterpriseslist, screenerStudioOrClykOps]);

  return (
    <div className="generationkey-container">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="heading">
        <img src={keyicon} alt="" className="headerimg" />
        <div>
          <Typography variant="h6">Generate Key</Typography>
          <Typography className="title">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit...
          </Typography>
        </div>
      </div>
      <Divider style={{ margin: "20px 0" }} />
      <div>
        <FormControlLabel
          control={
            <Switch value={extenalUser} onChange={handleLicenseTypeChange} />
          }
          label="Update License"
        />
      </div>
      <div>
        <div>
          <Typography className="input-label" variant="body2">
            Select Option
          </Typography>
          <FormControlLabel
            control={
              <Radio
                checked={screenerStudioOrClykOps === "screenerStudio"}
                onChange={(e) => {
                  setScreenerStudioOrClykOps(e.target.value);
                }}
                value="screenerStudio"
              />
            }
            label="Screener Studio"
          />
          <FormControlLabel
            control={
              <Radio
                checked={screenerStudioOrClykOps === "ClykOps"}
                onChange={(e) => {
                  setScreenerStudioOrClykOps(e.target.value);
                }}
                value="ClykOps"
              />
            }
            label="ClykOps"
          />
        </div>
      </div>

      {/* Client Name Field with Error Display */}
      <div>
        <Typography className="input-label" variant="body2">
          Client Name
        </Typography>
        <Select
          onChange={handleOrganizationChange}
          input={<OutlinedInput />}
          fullWidth
          className="element-select"
          displayEmpty
          error={!!errors.ClientName}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 300,
                overflowY: "auto",
              },
            },
          }}
        >
          {filteredEnterprises?.length > 0 &&
            filteredEnterprises.map((item) => (
              <MenuItem key={item.EnterpriseID} value={item.EnterpriseID}>
                <Typography variant="body1">{item?.EnterpriseName}</Typography>
              </MenuItem>
            ))}
        </Select>
        {errors.ClientName && (
          <FormHelperText error>{errors.ClientName}</FormHelperText>
        )}
      </div>

      {screenerStudioOrClykOps === "ClykOps" && (
        <>
          <div className="flex-container">
            <div style={{ flex: 1 }}>
              <Typography className="input-label" variant="body2">
                Element Type
              </Typography>
              <Select
                multiple
                value={selectedElements?.map((el) => el.ModuleName)}
                onChange={handleElementChange}
                input={<OutlinedInput />}
                renderValue={(selected) =>
                  selected.length === 0
                    ? "Select elements"
                    : selected.join(", ")
                }
                fullWidth
                className="element-select"
                displayEmpty
                error={!!errors.selectedElements}
              >
                <MenuItem disabled value="">
                  <Typography variant="body1">Select elements</Typography>
                </MenuItem>
                {elementsSidebar?.data?.map((element) => (
                  <MenuItem
                    key={element.ModuleName}
                    value={element?.ModuleName}
                  >
                    {element.ModuleName}
                  </MenuItem>
                ))}
              </Select>
              {errors.selectedElements && (
                <FormHelperText error>{errors.selectedElements}</FormHelperText>
              )}
              <Box
                className="chip-container"
                sx={{
                  padding: "10px 0px",
                }}
              >
                {selectedElements.map((element) => (
                  <Chip
                    key={element.ModuleTypeID}
                    label={element.ModuleName}
                    onDelete={() => {
                      setSelectedElements((prev) =>
                        prev.filter(
                          (el) => el.ModuleTypeID !== element.ModuleTypeID,
                        ),
                      );
                      validateSelectedElements(
                        selectedElements.filter(
                          (el) => el.ModuleTypeID !== element.ModuleTypeID,
                        ),
                      );
                    }}
                    style={{ backgroundColor: "#F2F4F7", color: "#101828" }}
                  />
                ))}
              </Box>
            </div>
          </div>
        </>
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "10px",
          marginTop: "20px",
          flexWrap: "wrap",
        }}
      >
        {/* Number of End Users */}
        <div style={{ flex: "1 1 22%", minWidth: "200px" }}>
          <Typography className="input-label" variant="body2">
            Number of End Users
          </Typography>
          <TextField
            type="number"
            placeholder="Enter number of end users"
            fullWidth
            size="small"
            error={!!errors.numEndUsers}
            helperText={errors.numEndUsers}
            onChange={handleChange(setNumEndUsers, "numEndUsers")}
            value={numEndUsers}
            disabled={isPerpetual}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={isPerpetual}
                onChange={() => setIsPerpetual(!isPerpetual)}
              />
            }
            label="Perpetual"
          />
        </div>

        {screenerStudioOrClykOps === "ClykOps" && (
          <>
            <div style={{ flex: "1 1 30%", minWidth: "280px" }}>
              <Typography className="input-label" variant="body2">
                Number of Administrators
              </Typography>
              <TextField
                select
                value={numAdmins}
                onChange={handleChange(setNumAdmins, "numAdmins")}
                fullWidth
                size="small"
                error={!!errors.numAdmins}
                helperText={errors.numAdmins}
              >
                <MenuItem value="">
                  <Typography variant="body2">
                    Select number of administrators
                  </Typography>
                </MenuItem>
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={3}>3</MenuItem>
              </TextField>
            </div>

            <div style={{ flex: "1 1 30%", minWidth: "280px" }}>
              <Typography className="input-label" variant="body2">
                Number of Power Users
              </Typography>
              <TextField
                type="number"
                placeholder="Enter number of power users"
                fullWidth
                size="small"
                onChange={handleChange(setNumPowerUsers, "numPowerUsers")}
                error={!!errors.numPowerUsers}
                helperText={errors.numPowerUsers}
                disabled={isPerpetual2}
                value={numPowerUsers}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isPerpetual2}
                    onChange={() => setIsPerpetual2(!isPerpetual2)}
                  />
                }
                label="Perpetual"
              />
            </div>

            <div style={{ flex: "1 1 30%", minWidth: "280px" }}>
              <Typography className="input-label" variant="body2">
                Number of Auditor Users
              </Typography>
              <TextField
                type="number"
                placeholder="Enter number of auditor users"
                fullWidth
                size="small"
                onChange={handleChange(setNumAuditorUsers, "numAuditorUsers")}
                error={!!errors.numAuditorUsers}
                helperText={errors.numAuditorUsers}
                disabled={isPerpetualAuditor}
                value={numAuditorUsers}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isPerpetualAuditor}
                    onChange={() => setIsPerpetualAuditor(!isPerpetualAuditor)}
                  />
                }
                label="Perpetual"
              />
            </div>

            <div style={{ flex: "1 1 30%", minWidth: "280px" }}>
              <Typography className="input-label" variant="body2">
                User Data Fields to Show
              </Typography>
              <Select
                multiple
                value={selectedUserDataFields}
                onChange={(e) => {
                  setSelectedUserDataFields(e.target.value);
                  setErrors((prev) => ({
                    ...prev,
                    selectedUserDataFields: undefined,
                  }));
                }}
                input={<OutlinedInput size="small" />}
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return "Select user data fields";
                  }
                  return selected
                    .map((field) =>
                      field === "EmployeeNumber"
                        ? "Employee ID"
                        : field === "UserName"
                          ? "User Name"
                          : field,
                    )
                    .join(", ");
                }}
                fullWidth
                className="element-select"
                displayEmpty
                size="small"
                error={!!errors.selectedUserDataFields}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    padding: "0px",
                  },
                }}
              >
                <MenuItem disabled value="">
                  <Typography variant="body2">
                    Select user data fields
                  </Typography>
                </MenuItem>
                <MenuItem value="EmployeeNumber">
                  <Checkbox
                    checked={
                      selectedUserDataFields.indexOf("EmployeeNumber") > -1
                    }
                  />
                  <Typography variant="body2">Employee ID</Typography>
                </MenuItem>
                <MenuItem value="UserName">
                  <Checkbox
                    checked={selectedUserDataFields.indexOf("UserName") > -1}
                  />
                  <Typography variant="body2">User Name</Typography>
                </MenuItem>
              </Select>
              {errors.selectedUserDataFields && (
                <FormHelperText error>
                  {errors.selectedUserDataFields}
                </FormHelperText>
              )}
              <Box
                className="chip-container"
                sx={{
                  padding: "10px 0px",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px",
                }}
              >
                {selectedUserDataFields.map((field) => {
                  const displayName =
                    field === "EmployeeNumber"
                      ? "Employee ID"
                      : field === "UserName"
                        ? "User Name"
                        : field;
                  return (
                    <Chip
                      key={field}
                      label={displayName}
                      onDelete={() => {
                        setSelectedUserDataFields((prev) =>
                          prev.filter((f) => f !== field),
                        );
                      }}
                      style={{ backgroundColor: "#F2F4F7", color: "#101828" }}
                    />
                  );
                })}
              </Box>
            </div>
          </>
        )}

        {screenerStudioOrClykOps === "screenerStudio" && (
          <>
            <div style={{ flex: "1 1 30%", minWidth: "280px" }}>
              <Typography className="input-label" variant="body2">
                Number of recordings
              </Typography>
              <TextField
                type="number"
                placeholder="Enter Number of recordings"
                fullWidth
                size="small"
                error={!!errors.numrecordings}
                helperText={errors.numrecordings}
                onChange={handleChange(setNumRecordings, "numrecordings")}
                value={numrecordings}
                disabled={isPerpetualRecordings}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isPerpetualRecordings}
                    onChange={() =>
                      setIsPerpetualRecordings(!isPerpetualRecordings)
                    }
                  />
                }
                label="Perpetual"
              />
            </div>

            <div style={{ flex: "1 1 30%", minWidth: "280px" }}>
              <Typography className="input-label" variant="body2">
                Number of Sticher
              </Typography>
              <TextField
                type="number"
                placeholder="Enter Number of Sticher"
                fullWidth
                size="small"
                onChange={handleChange(setNumberOfSticher, "NumberOfSticher")}
                value={NumberOfSticher}
              />
            </div>
          </>
        )}
      </div>

      <div className="flex-container">
        <div style={{ flex: 1 }}>
          <Typography className="input-label" variant="body2">
            Choose Start Date
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={startDate}
              disabled={extenalUser}
              onChange={(newValue) => {
                setStartDate(newValue);
                setErrors((prev) => ({ ...prev, startDate: undefined }));
                validateForm();
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  error={!!errors.startDate}
                  helperText={errors.startDate}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <CalendarToday style={{ marginRight: "10px" }} />
                    ),
                  }}
                />
              )}
            />
          </LocalizationProvider>
        </div>

        <div style={{ flex: 1 }}>
          <Typography className="input-label" variant="body2">
            Choose End Date
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={endDate}
              disabled={extenalUser}
              onChange={(newValue) => {
                setEndDate(newValue);
                setErrors((prev) => ({ ...prev, endDate: undefined }));
                validateForm();
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  error={!!errors.endDate}
                  helperText={errors.endDate}
                  InputProps={{
                    endAdornment: (
                      <CalendarToday style={{ marginRight: "10px" }} />
                    ),
                  }}
                />
              )}
            />
          </LocalizationProvider>
        </div>
      </div>

      <div className="centered-button">
        <Button
          variant="contained"
          onClick={handleClick}
          className="generate-button"
          disabled={loading}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "Generate Key"
          )}
        </Button>
      </div>
    </div>
  );
};

export default GenerateKey;
